import React from 'react'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean
}

export const Input: React.FC<InputProps> = ({ invalid, ...props }) => {
  return (
    <input
      {...props}
      style={{
        width: '100%',
        padding: '8px 12px',
        border: `1px solid ${invalid ? '#d91515' : '#ccc'}`,
        borderRadius: '4px',
        fontSize: '14px',
        ...props.style,
      }}
    />
  )
}
